import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompletaComponent } from './completa.component';

const routes: Routes = [
  {
    path: '',
    component: CompletaComponent
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompletaRoutingModule { }
